<mat-label class="subHeading">Order Type</mat-label>
<mat-select class="order" placeholder="All">
    <mat-option *ngFor="let orderObj of orderType" [value]="orderObj.type.id">
        {{orderObj.order_type}}
    </mat-option>
</mat-select>